module.exports = __webpack_public_path__ + "icon_services_status_open.12308.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_services_status_open.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_services_status_open.svg
// module chunks = main